import React, { useState, useEffect } from "react";
import "./index.scss";

import { useNavigate, useParams } from "react-router-dom";
import RealisationService from "../../../services/realisation/realisation.service";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { showErrorToaster } from "../../../components/toaster/error";
import { showSuccessToaster } from "../../../components/toaster/success";

const realisationService = new RealisationService();

const RealisationForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    image: "",
    slug: "",
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [error, setError] = useState("");

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "table"],
      ["clean"],
    ],
    table: true,
  };

  const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "link",
    "table",
  ];

  useEffect(() => {
    if (id) {
      const fetchRealisation = async () => {
        try {
          const response = await realisationService.getRealisationById(id);
          const data = response.data;

          // ✅ Formater la date pour l'input type="date"
          const formattedDate = data.date
            ? new Date(data.date).toISOString().split("T")[0]
            : "";

          setFormData({
            ...data,
            date: formattedDate,
          });

          setImagePreview(data.image || null);
        } catch (error) {
          showErrorToaster("Erreur lors du chargement des données.");
        }
      };
      fetchRealisation();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validation
    if (!formData.title || !formData.description || !formData.date) {
      setError("Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("date", formData.date);
      formDataToSend.append("slug", formData.slug);

      if (formData.image instanceof File) {
        formDataToSend.append("image", formData.image);
      }

      if (id) {
        await realisationService.updateRealisation(id, formDataToSend);
        showSuccessToaster("Modification réussie.");
      } else {
        await realisationService.createRealisation(formDataToSend);
        showSuccessToaster("Création réussie.");
      }

      navigate("/realisation-liste");
    } catch (err) {
      showErrorToaster(
        err.response
          ? err.response.data.message
          : "Une erreur est survenue, veuillez réessayer."
      );
    }
  };

  return (
    <div className="job-form-container">
      <h1>{id ? "Modifier réalisation" : "Créer réalisation"}</h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}

        <div className="form-group">
          <label style={{ color: "black" }}>Titre :</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label style={{ color: "black" }}>Description :</label>
          <ReactQuill
            value={formData.description}
            onChange={handleDescriptionChange}
            theme="snow"
            placeholder="Écris ton texte ici..."
            modules={modules}
            formats={formats}
          />
        </div>

        <div className="form-group">
          <label style={{ color: "black" }}>Date :</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label style={{ color: "black" }}>Image :</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />
          {imagePreview && <p>{imagePreview}</p>}
          <p>
            {formData.image instanceof File
              ? formData.image.name
              : formData.image
              ? "Image existante"
              : "Aucune image sélectionnée"}
          </p>
        </div>

        <button type="submit" className="submit-button">
          {id ? "Modifier" : "Créer"}
        </button>
      </form>
    </div>
  );
};

export default RealisationForm;
